import loadable from '@loadable/component';
import Spinner from '../../components/Reusable/Spinner';
import APIS from '../../constant/EndPoint';
import useGetHook from '../../customHooks/useGetHook';
import DispatchManifestIcon from '../../Icons/DispatchManifestIcon';
//@ts-ignore
import { tw } from '@careinfo/tailwind';
import Skeleton from '../../components/Reusable/Skeleton';

const ManifestListComponent = loadable(
  () => import('../../components/VehicleManifest/VehicleManifestList')
);

const VehicleManifestList = () => {
  const { data: profile, isLoading } = useGetHook({
    queryKey: [`profile`],
    url: `${APIS.USER}me/`,
    params: {},
  });

  return (
    <>
      {isLoading ? (
        <Skeleton />
      ) : (
        <>
          <div
            className={tw`w-full flex justify-left gap-x-2 mb-6 uppercase font-extrabold items-center`}
          >
            <DispatchManifestIcon />
            <span className={tw`text-[#5E5757] font-bold text-xl`}>
              Vehicle Manifest
            </span>
          </div>
          <ManifestListComponent defaultBranch={profile?.default_branch} />
        </>
      )}
    </>
  );
};

export default VehicleManifestList;
